import styled from 'styled-components';

const GroupTitle = styled.span`
  font-size: var(--cc_size_text_s);
  font-weight: 500;
  text-align: center;
  color: var(--cc_color_text_default);
`;

export default GroupTitle;
